import { API_URL } from "env";
interface CreateFeatureParams {
    name: string;
    description: string;
}
async function createFeature({ name, description }: CreateFeatureParams): Promise<number | null> {
    const token = localStorage.getItem("token");
    try {
        if (!token) throw new Error("No token found");
        const response = await fetch(`${API_URL}api/v1/be/features`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
                name,
                description,
            }),
        });
        const data = await response.json();
        if (!data) {
            throw new Error(data.message || "Failed to create feature");
        }
        return data.id || null;
    }
    catch (error) {
        console.error("Error creating feature:", error);
        return null;
    }
}

export default createFeature;